import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAnswers,
  PageScores,
  PageRankings,
  PageArticleStats,
  PageAchievements,
} from '../pages/reports';
import PageTeacherReport from '../pages/reports/PageTeacherReport.jsx';

const RouteAnswers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/teacher`} />
      </Route>
      <Route exact path={`${path}/teacher`}>
        <PageTeacherReport />
      </Route>
      <Route exact path={`${path}/scores`}>
        <PageAnswers />
      </Route>
      <Route exact path={`${path}/performance`}>
        <PageScores />
      </Route>
      <Route exact path={`${path}/rankings`}>
        <PageRankings />
      </Route>
      <Route exact path={`${path}/articles`}>
        <PageArticleStats />
      </Route>
      <Route exact path={`${path}/achievements`}>
        <PageAchievements />
      </Route>
    </Switch>
  );
};

export default RouteAnswers;
